import { useMediaQuery } from "@mui/material";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import './main.css';

const MySkills = () => {
    const space = useMediaQuery('(max-width:600px)')

    return (
        <div className="m-5 text-white d-flex flex-column">
            {
                space && <div className="mt-4"></div>
            }
            <h1 className="divTitle">My Skills:</h1>
            <div className="m-2 ms-4 d-flex align-content-center">
                <FiberManualRecordIcon sx={{ color: '#ff0093' }} />
                <p className="ms-2 divText">
                    HTML with a semantic sense.
                </p>
            </div>
            <div className="m-2 ms-4 d-flex align-content-center">
                <FiberManualRecordIcon sx={{ color: '#ff0093' }} />
                <p className="ms-2 divText">
                    CSS including design libraries such as Material UI, Bootstrap, Materialize etc…
                </p>
            </div>
            <div className="m-2 ms-4 d-flex align-content-center">
                <FiberManualRecordIcon sx={{ color: '#ff0093' }} />
                <p className="ms-2 divText">
                    JavaScript.
                </p>
            </div>
            <div className="m-2 ms-4 d-flex align-content-center">
                <FiberManualRecordIcon sx={{ color: '#ff0093' }} />
                <p className="ms-2 divText">
                    React Js based on functional components.
                </p>
            </div>
            <div className="m-2 ms-4 d-flex align-content-center">
                <FiberManualRecordIcon sx={{ color: '#ff0093' }} />
                <p className="ms-2 divText">
                    Formik to make complex forms in a short time.
                </p>
            </div>
            <div className="m-2 ms-4 d-flex align-content-center">
                <FiberManualRecordIcon sx={{ color: '#ff0093' }} />
                <p className="ms-2 divText">
                    Formik to make complex forms in a short time.
                </p>
            </div>
            <div className="m-2 ms-4 d-flex align-content-center">
                <FiberManualRecordIcon sx={{ color: '#ff0093' }} />
                <p className="ms-2 divText">
                    Auth0 to make a user login in a short time.
                </p>
            </div>
            <div className="m-2 ms-4 d-flex align-content-center">
                <FiberManualRecordIcon sx={{ color: '#ff0093' }} />
                <p className="ms-2 divText">
                    Iustrator and Photoshop.
                </p>
            </div>
            <div className="m-2 ms-4 d-flex align-content-center">
                <FiberManualRecordIcon sx={{ color: '#ff0093' }} />
                <p className="ms-2 divText">
                    Firebase.
                </p>
            </div>
            <div className="m-2 ms-4 d-flex align-content-center">
                <FiberManualRecordIcon sx={{ color: '#ff0093' }} />
                <p className="ms-2 divText">
                    Git and GitHub.
                </p>
            </div>
        </div>
    );
}


export default MySkills;